<button *ngIf="canSaveDraft && !saved" type="button" class="btn"
  [disabled]="pending || !canCreate" (click)="requestSaveDraft()">
  Save as draft
</button>
<button *ngIf="saved && draft && canDeleteDraft" type="button" class="btn btn-danger"
  [disabled]="pending" (click)="requestDeleteDraft()">
  Delete draft
</button>
<button *ngIf="(!saved || draft) && !creationSteps.length" type="submit" class="btn btn-primary"
  [attr.form]="formId || null" [disabled]="pending || !canCreate">
  {{ createLabel }}
</button>
<button *ngFor="let item of creationSteps" type="button" class="btn btn-primary"
  [disabled]="pending || !canCreate" (click)="requestCreateAtStep(item.step.id)">
  {{ item.step.create_button_label || ('Save as ' + item.step.name) }}
</button>
<button *ngFor="let transition of transitions" type="button" class="btn"
  [class.btn-primary]="transition.button_style === 'primary'"
  [class.btn-danger]="transition.button_style === 'danger'"
  [class.btn-warning]="transition.button_style === 'warning'"
  [disabled]="pending"
  (click)="requestTransition(transition.action_code)">
  {{ transition.button_label }}
</button>
<span class="text-danger small" role="alert" *ngIf="errorMessage">{{ errorMessage }}</span>
